/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type Rates = {
  inputTokens?: number | undefined;
  outputTokens?: number | undefined;
  cachedTokens?: number | undefined;
  reasoningTokens?: number | undefined;
  characters?: number | undefined;
  seconds?: number | undefined;
  image?: number | undefined;
  imageTiers?: { [k: string]: number } | undefined;
  searches?: number | undefined;
};

export const CatalogPricePreviewSource = {
  OrgOverride: "org_override",
  ClusterDefault: "cluster_default",
  Unpriced: "unpriced",
} as const;
export type CatalogPricePreviewSource = ClosedEnum<
  typeof CatalogPricePreviewSource
>;

export type CatalogPricePreview = {
  rates: Rates | null;
  source: CatalogPricePreviewSource;
};

/** @internal */
export const Rates$inboundSchema: z.ZodType<Rates, z.ZodTypeDef, unknown> = z
  .object({
    input_tokens: z.number().optional(),
    output_tokens: z.number().optional(),
    cached_tokens: z.number().optional(),
    reasoning_tokens: z.number().optional(),
    characters: z.number().optional(),
    seconds: z.number().optional(),
    image: z.number().optional(),
    image_tiers: z.record(z.number()).optional(),
    searches: z.number().optional(),
  }).transform((v) => {
    return remap$(v, {
      "input_tokens": "inputTokens",
      "output_tokens": "outputTokens",
      "cached_tokens": "cachedTokens",
      "reasoning_tokens": "reasoningTokens",
      "image_tiers": "imageTiers",
    });
  });
/** @internal */
export type Rates$Outbound = {
  input_tokens?: number | undefined;
  output_tokens?: number | undefined;
  cached_tokens?: number | undefined;
  reasoning_tokens?: number | undefined;
  characters?: number | undefined;
  seconds?: number | undefined;
  image?: number | undefined;
  image_tiers?: { [k: string]: number } | undefined;
  searches?: number | undefined;
};

/** @internal */
export const Rates$outboundSchema: z.ZodType<
  Rates$Outbound,
  z.ZodTypeDef,
  Rates
> = z.object({
  inputTokens: z.number().optional(),
  outputTokens: z.number().optional(),
  cachedTokens: z.number().optional(),
  reasoningTokens: z.number().optional(),
  characters: z.number().optional(),
  seconds: z.number().optional(),
  image: z.number().optional(),
  imageTiers: z.record(z.number()).optional(),
  searches: z.number().optional(),
}).transform((v) => {
  return remap$(v, {
    inputTokens: "input_tokens",
    outputTokens: "output_tokens",
    cachedTokens: "cached_tokens",
    reasoningTokens: "reasoning_tokens",
    imageTiers: "image_tiers",
  });
});

export function ratesToJSON(rates: Rates): string {
  return JSON.stringify(Rates$outboundSchema.parse(rates));
}
export function ratesFromJSON(
  jsonString: string,
): SafeParseResult<Rates, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Rates$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Rates' from JSON`,
  );
}

/** @internal */
export const CatalogPricePreviewSource$inboundSchema: z.ZodNativeEnum<
  typeof CatalogPricePreviewSource
> = z.nativeEnum(CatalogPricePreviewSource);
/** @internal */
export const CatalogPricePreviewSource$outboundSchema: z.ZodNativeEnum<
  typeof CatalogPricePreviewSource
> = CatalogPricePreviewSource$inboundSchema;

/** @internal */
export const CatalogPricePreview$inboundSchema: z.ZodType<
  CatalogPricePreview,
  z.ZodTypeDef,
  unknown
> = z.object({
  rates: z.nullable(z.lazy(() => Rates$inboundSchema)),
  source: CatalogPricePreviewSource$inboundSchema,
});
/** @internal */
export type CatalogPricePreview$Outbound = {
  rates: Rates$Outbound | null;
  source: string;
};

/** @internal */
export const CatalogPricePreview$outboundSchema: z.ZodType<
  CatalogPricePreview$Outbound,
  z.ZodTypeDef,
  CatalogPricePreview
> = z.object({
  rates: z.nullable(z.lazy(() => Rates$outboundSchema)),
  source: CatalogPricePreviewSource$outboundSchema,
});

export function catalogPricePreviewToJSON(
  catalogPricePreview: CatalogPricePreview,
): string {
  return JSON.stringify(
    CatalogPricePreview$outboundSchema.parse(catalogPricePreview),
  );
}
export function catalogPricePreviewFromJSON(
  jsonString: string,
): SafeParseResult<CatalogPricePreview, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CatalogPricePreview$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CatalogPricePreview' from JSON`,
  );
}
